
















































































import { Component } from "vue-property-decorator";
import MagicValidator from "../../../magic/MagicValidator.vue";
import WidgetBase from "../WidgetBase";

@Component({
  name: "CheckBoxWidget",
  components: {MagicValidator}
})
export default class CheckBoxWidget extends WidgetBase implements App.PuttedWidgetComponent {
  private list: any[] = [];
  private radio: any = "";
  private checkList: any = [];
  private select: any = "";

  setValue(value: string) {
    console.log(value);
  }

  mounted() {
    let list;
    try {
      list = JSON.parse(this.widget.property.configValue);
    } catch (error) {
      list = [
        {label : '选项1', value : '1'},
        {label : '选项2', value : '2'},
        {label : '选项3', value : '2'},
      ];
    }
    this.list = list;

    if (this.widget.value) {  //编辑状态
      this.value = this.widget.value;
      if (this.widget.preset === "group") {
        if (this.widget.multiple) {
          this.checkList = this.value.split(',');
        } else {
          this.radio = this.value;
        }
      } else {  //下拉
        this.select = this.widget.multiple ? this.value.split(',') : this.value;
      }
    } else {
      this.handleDefault();
    }
  }

  /*渲染默认值*/
  handleDefault() {
    const defaultValues: any = [];  //defaultValues.length长度为0代表未设置默认值
    this.list.map((item: any) => {
      if (item.default) {
        defaultValues.push(item.value);
      }
    });
    if (this.widget.preset === "group") {  //checkbox/radio
      if (defaultValues.length === 0) {
        if (this.widget.multiple) {
          this.checkList = [];
          this.value = this.checkList.join();
        } else {
          this.radio = "";
          this.value = this.radio;
        }
      } else {
        if (this.widget.multiple) {
          this.checkList = defaultValues;
          this.value = this.checkList.join();
        } else {
          this.radio = defaultValues[0];
          this.value = this.radio;
        }
      }
    } else {  //下拉
      if (defaultValues.length === 0) {
        if (this.widget.multiple) {
          this.select = [];
          this.value = this.select.join();
        } else {
          this.select = "";
        }
      } else {
        if (this.widget.multiple) {
          this.select = defaultValues;
          this.value = this.select.join();
        } else {
          this.select = defaultValues[0];
        }
      }
    }
  }

  /*radio改变*/
  changeRadio() {
    this.value = this.radio;
  }

  /*checkbox改变*/
  changeCheckBox() {
    this.value = this.checkList.join();
  }

  /*下拉改变*/
  changeSelect() {
    this.value = Array.isArray(this.select) ? this.select.join() : this.select;
  }

  get selectText() {
    if (this.value && this.list.length) {
      return this.value.split(',').map((i: any) => {
        const op = this.list.find(j => j.value === i);
        return op.label;
      }).join();
    }
    return ''
  }
}
